/**
 * Which checkout page a shopper is sent to.
 *
 * Brandclub has two designs of the pay page — `/checkout` (older) and
 * `/checkout_simplified` (its rebuild) — and a Split flag decides per brand who
 * gets which. Three buttons make that decision: the bag drawer and the floating
 * checkout bar in this bundle, and the `/mybag` page in the landing-page SPA.
 *
 * They must agree, and they did not.
 *
 * THE BUG (live on PetArmor, 2026-09-02). Split rules match on an `appId`
 * attribute. The drawer sent `APPID` — `HOST_DOMAIN` minus the protocol, i.e.
 * wherever the bundle happens to be SERVED FROM. Off the App Proxy that string
 * is the brand's own host, so it coincided with the `domainName` the SPA sends
 * and the two agreed by accident. On the App Proxy `HOST_DOMAIN` becomes
 * `<store>/a/sos`, so the drawer started asking about a URL that matches no
 * rule. Measured against the live rule:
 *
 *   app-petarmor-dtc.shopperos.app   (what /mybag sends)     → on
 *   shop.gund.com                    (another live brand)    → on
 *   petarmor.com/a/sos               (what the drawer sent)  → off
 *
 * Same shopper, same bag: the new checkout from `/mybag`, the old one from the
 * drawer. Meanwhile the floating bar never consulted the flag at all and
 * hardcoded `/checkout`.
 *
 * The rule this module exists to enforce: ask Split who the BRAND is
 * (`domainConfig.domainName`, which is the bootstrap's `identity.hostname`),
 * never where the code is running.
 */

/**
 * The `appId` attribute to evaluate `CHECKOUT_SIMPLIFIED_FLAG` (common-ui) with.
 *
 * `fallback` is the caller's `APPID`, kept for the window before the app config
 * resolves: answering exactly as today while we do not yet know the brand is
 * safe, whereas guessing would flip a shopper to a different checkout page
 * mid-session.
 */
export function resolveCheckoutSplitAppId(
  domainConfig: { domainName?: string } | undefined,
  fallback: string,
): string {
  const domainName = domainConfig?.domainName?.trim();
  return domainName || fallback;
}
